import { useTranslation } from 'react-i18next'

import { showSnackbarNotification } from '@helpers'

export const useCopy = () => {
  const { t } = useTranslation()

  async function handleWriteClipboardText(text: string) {
    try {
      await navigator.clipboard.writeText(text)

      showSnackbarNotification({
        text: t('ganttCreate.timelineForm.additionalFieldsForm.copyAlert'),
        options: {
          variant: 'success',
        },
      })
    } catch (error) {
      console.error(error)
    }
  }

  return handleWriteClipboardText
}
